import * as React from 'react';

import { StyleSheet } from 'react-native';

import TrophyIcon from 'components/icons/trophy';
import { Box, Typography } from 'components/ui';

import { getQuestText } from '../custom-text';

export const QuestLibraryHeader = () => {
  return (
    <Box style={styles.container}>
      <TrophyIcon mt={{ base: '$1_5', md: '$2' }} />
      <Typography style={styles.title}>{getQuestText()}</Typography>
    </Box>
  );
};

const styles = StyleSheet.create({
  container: { flexDirection: 'row' },
  title: { marginLeft: 8 },
});
